var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-wrapper"},[_c('div',{staticClass:"toolbox"},[_vm._t("default")],2),_c('div',{staticClass:"help-line"},[_vm._v("\n        "+_vm._s(_vm.currentHelp)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }